// extracted by extract-css-chunks-webpack-plugin
module.exports = {"loading":"t0Okb","mobile":"v5GQc","tablet":"pdV5l"};